// Source
import * as HelperSrc from "../../HelperSrc";
import * as ModelDocument from "../../model/custom/Document";

export default class StoreDocumentPreview {
    storageSet = (value: ModelDocument.Idata): void => {
        HelperSrc.writeStorage<ModelDocument.Idata>("document_preview", value);

        HelperSrc.storageDispatchEvent("document_preview");
    };

    storageGet = (): ModelDocument.Idata | undefined => {
        return HelperSrc.readStorage<ModelDocument.Idata>("document_preview");
    };

    storageRemove = (): void => {
        HelperSrc.removeStorage("document_preview");
    };
}
